"use client";


import Header from "@/layout/headers/header";
import Wrapper from "@/layout/wrapper";
// import { promises as fs } from "fs";
// import BlogArea from '@/components/blogs/blog-area';//
import Footer from "@/layout/footers/footer";
import { Suspense } from "react";
import Loading from "./loading";

export default async function TermsAndConditionsPage() {
  // const file = await fs.readFile(
  //   process.cwd() + "/src/app/product-data.json",
  //   "utf8"
  // );

  return (
    <Wrapper>
      {/* <Loading /> */}
      {/* header start */}

      <Header />

      {/* header end */}

      <main>
        <Suspense fallback={<Loading />}>
         <section className="terms__area pt-30 pb-100">
        <div className="container">
          <style jsx>{`
            .terms-container {
              background: linear-gradient(180deg, #ffffff 0%, #f7f5ff 100%);
              padding: 40px;
              border-radius: 20px;
              box-shadow: 0 8px 25px rgba(160, 128, 255, 0.15);
              border: 1px solid #e6e0ff;
              max-width: 900px;
              margin: 0 auto;
            }

            .terms-title {
              text-align: center;
              color: #6b4eff;
              font-size: 32px;
              font-weight: 700;
              margin-bottom: 20px;
            }

            .terms-intro {
              text-align: center;
              color: #4b4b4b;
              margin-bottom: 40px;
              line-height: 1.7;
              font-size: 16px;
            }

            .terms-section {
              background: white;
              border: 1px solid #e9e4ff;
              padding: 25px;
              border-radius: 16px;
              box-shadow: 0 4px 15px rgba(150, 120, 255, 0.1);
              margin-bottom: 25px;
              transition: all 0.3s ease;
            }

            .terms-section:hover {
              box-shadow: 0 6px 18px rgba(107, 78, 255, 0.2);
              transform: translateY(-3px);
            }

            .terms-section h3 {
              color: #6b4eff;
              font-size: 20px;
              font-weight: 600;
              margin-bottom: 10px;
            }

            .terms-section p {
              color: #444;
              font-size: 15px;
              line-height: 1.8;
            }

            @media (max-width: 768px) {
              .terms-container {
                padding: 25px;
              }

              .terms-title {
                font-size: 26px;
              }

              .terms-section {
                padding: 20px;
              }
            }
          `}</style>

          <div className="terms-container">
            <h2 className="terms-title">Terms & Conditions</h2>
            <p className="terms-intro">
              Welcome to <strong>Tashlimafamilyshop LLC</strong> — a trusted
              online destination for family essentials. By using our website,
              you agree to follow the terms outlined below to ensure a safe and
              secure shopping experience for everyone.
            </p>

            <div className="terms-section">
              <h3>1. Acceptance of Terms</h3>
              <p>
                By accessing or using this website, you confirm that you are at
                least 18 years old and agree to comply with these terms. If you
                do not agree, please discontinue using the site.
              </p>
            </div>

            <div className="terms-section">
              <h3>2. Use of Our Website</h3>
              <p>
                You may use our website only for lawful shopping purposes. Any
                misuse of the site, including unauthorized access or fraudulent
                activity, is strictly prohibited and may result in account
                termination.
              </p>
            </div>

            <div className="terms-section">
              <h3>3. Account Responsibility</h3>
              <p>
                You are responsible for keeping your account credentials secure.
                If you suspect unauthorized access, please contact us
                immediately. Tashlimafamilyshop is not responsible for losses
                resulting from unauthorized account use.
              </p>
            </div>

            <div className="terms-section">
              <h3>4. Product Information</h3>
              <p>
                We aim to provide accurate product descriptions and images, but
                slight variations may occur. Prices, availability, and details
                are subject to change without prior notice.
              </p>
            </div>

            <div className="terms-section">
              <h3>5. Orders & Payments</h3>
              <p>
                All orders are subject to acceptance and stock availability. We
                reserve the right to cancel or reject any order in case of
                suspected fraud or payment verification issues. Customers will
                be notified in such cases.
              </p>
            </div>

            <div className="terms-section">
              <h3>6. Shipping & Delivery</h3>
              <p>
                We strive to deliver your products promptly and safely. Delivery
                times may vary depending on location and product availability.
              </p>
            </div>

            <div className="terms-section">
              <h3>7. Returns & Refunds</h3>
              <p>
                For eligible items, returns or exchanges may be requested within
                the specified return period. Refunds will be processed according
                to our Return Policy.
              </p>
            </div>

            <div className="terms-section">
              <h3>8. Limitation of Liability</h3>
              <p>
                Tashlimafamilyshop LLC is not responsible for indirect or
                consequential losses related to website usage, order delays, or
                data inaccuracies.
              </p>
            </div>

            <div className="terms-section">
              <h3>9. Policy Updates</h3>
              <p>
                We may modify these Terms & Conditions at any time without prior
                notice. Please review them periodically for updates.
              </p>
            </div>

            <div className="terms-section">
              <p>
                By using this website, you acknowledge that you have read,
                understood, and agreed to these Terms & Conditions. Thank you
                for shopping with <strong>Tashlimafamilyshop LLC</strong> —
                where families shop with confidence. 💜
              </p>
            </div>
          </div>
        </div>
      </section>
        </Suspense>
      </main>

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
}
